import React from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ImagePreviewModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  imageSrc: string | null;
  title: string;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  show,
  onHide,
  onConfirm,
  imageSrc,
  title
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      aria-labelledby="image-preview-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="image-preview-modal">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {imageSrc && (
          <Image 
            src={imageSrc} 
            fluid 
            className="mb-3" 
            style={{ maxHeight: '400px', objectFit: 'contain' }} 
          />
        )}
        <p className="mt-3">{t('confirmImageSave')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('cancel')}
        </Button>
        <Button variant="warning" onClick={onConfirm}>
          {t('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImagePreviewModal;
